import { Button } from "components/atoms/button/button";
import { Modal } from "components/modal/modal";
import React from "react";
import Image from "next/legacy/image";
import {
  ModalContainer,
  ModalHeading,
  InfoText,
  SubHeading,
  LinkText,
  TextContainer,
  ButtonContainer
} from "./pause-subscription-modal.styles";
import CocoSad from "public/assets/coco-sad.svg";
import CocoHappy from "public/assets/coco-happy.svg";
import { IGetContentForPausedUserResponse } from "services/api/sessions/sessionService.types";
import { usePauseSubscriptionModal } from "./use-pause-subscription-modal";

const RenderLinkModalContent = ({
  onClose,
  content
}: {
  onClose: () => void;
  content: IGetContentForPausedUserResponse | null;
}) => {
  return (
    <>
      <Image src={CocoHappy} alt="coco-happy" />
      <ModalHeading>
        {content?.data.subscription_paused_followup_popup.title}
      </ModalHeading>
      <SubHeading>
        {content?.data.subscription_paused_followup_popup.subtitle}
      </SubHeading>
      <ButtonContainer>
        <Button
          onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
            e.stopPropagation();
            onClose();
          }}
          variant="primary"
        >
          Oke
        </Button>
      </ButtonContainer>
    </>
  );
};

const PauseSubscriptionModal = ({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}): JSX.Element => {
  const { isLinkClicked, UIContentsForPausedUser, setIsLinkClicked } =
    usePauseSubscriptionModal();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeIconProperties={{ isHidden: true }}
    >
      <ModalContainer
        onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
          e.stopPropagation()
        }
      >
        {isLinkClicked ? (
          <RenderLinkModalContent
            content={UIContentsForPausedUser}
            onClose={onClose}
          />
        ) : (
          <>
            <Image src={CocoSad} alt="Coco sad" />
            <ModalHeading>
              {UIContentsForPausedUser?.data.subscription_paused_popup.title}
            </ModalHeading>
            <SubHeading>
              {
                UIContentsForPausedUser?.data.subscription_paused_popup
                  .description
              }
            </SubHeading>

            {UIContentsForPausedUser?.data.subscription_paused_popup
              .top_info && (
              <TextContainer>
                <SubHeading>Info pembayaran dari </SubHeading>

                {UIContentsForPausedUser && (
                  <Image
                    height={24}
                    width={120}
                    alt="logo-company"
                    src={`${UIContentsForPausedUser?.meta.media_base_url}${UIContentsForPausedUser?.data.subscription_paused_popup.top_info.bank_logo.svg}`}
                  />
                )}
              </TextContainer>
            )}
            <ButtonContainer>
              <Button
                onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
                  e.stopPropagation();
                  onClose();
                }}
                variant="primary"
              >
                Oke
              </Button>
            </ButtonContainer>

            <TextContainer>
              <InfoText>Kalo udah bayar gimana?</InfoText>{" "}
              <LinkText
                onClick={(
                  e: React.MouseEvent<HTMLParagraphElement, MouseEvent>
                ) => {
                  e.stopPropagation();
                  setIsLinkClicked(true);
                }}
              >
                {
                  UIContentsForPausedUser?.data.subscription_paused_popup
                    .bottom_info.link_text
                }
              </LinkText>
            </TextContainer>
          </>
        )}
      </ModalContainer>
    </Modal>
  );
};

export { PauseSubscriptionModal };
